var map = {
	"./en": "D9mC",
	"./en.": "D9mC",
	"./en.js": "D9mC",
	"./en.json": "lqYt",
	"./pl": "9X1b",
	"./pl.": "9X1b",
	"./pl.js": "9X1b",
	"./pl.json": "OvGE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6HRe";